import Reveal from '@/components/base/Reveal';
import { companyProfile, organizations } from '@/mocks/site';

export default function About() {
  return (
    <section id="about" className="bg-background-50 px-5 py-16 pr-14 md:px-10 md:py-24 md:pr-20">
      <div className="mx-auto max-w-6xl">
        <Reveal variant="up">
          <div className="flex items-center gap-3">
            <span className="h-px w-8 bg-primary-500" />
            <p className="text-[10px] en-label text-primary-600">ABOUT US</p>
          </div>
          <h2 className="mt-4 font-heading text-[26px] font-black leading-tight text-foreground-950 md:text-[36px]">
            主催・運営
          </h2>
        </Reveal>

        <div className="mt-8 grid gap-6 md:mt-12 md:grid-cols-12 md:gap-10">
          {organizations.map((org, index) => (
            <Reveal
              key={org.name}
              variant={index === 0 ? 'left' : 'right'}
              delay={index * 100}
              className={index === 0 ? 'md:col-span-5' : 'md:col-span-7'}
            >
              <div className="flex h-full flex-col">
                <p className="en-label text-[10px] text-foreground-400">
                  {org.en} / {org.role}
                </p>
                <h3 className="mt-2.5 font-heading text-[21px] font-black text-foreground-950 md:text-[25px]">{org.name}</h3>
                <p className="mt-3.5 text-[12.5px] leading-[2] text-foreground-600">{org.text}</p>

                {org.image ? (
                  org.imageType === 'logo' ? (
                    <div className="group mt-6 flex h-[190px] w-full items-center justify-center overflow-hidden rounded-md border border-background-200 bg-background-50 p-5 sm:h-[240px] md:mt-auto md:h-[340px] md:p-8">
                      <img
                        src={org.image}
                        alt={org.imageAlt ?? `${org.name}の写真`}
                        className="h-full w-full object-contain object-center transition-transform duration-[1200ms] ease-out group-hover:scale-[1.03]"
                      />
                    </div>
                  ) : (
                    <div className="group mt-6 h-[200px] w-full overflow-hidden rounded-md border border-background-200 bg-background-100 sm:h-[260px] md:mt-auto md:h-[340px]">
                      <img
                        src={org.image}
                        alt={org.imageAlt ?? `${org.name}の写真`}
                        className="h-full w-full object-cover object-center transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
                      />
                    </div>
                  )
                ) : (
                  <div className="mt-6 flex h-[190px] w-full flex-col items-center justify-center gap-2 rounded-md border border-dashed border-background-400 bg-background-100 sm:h-[240px]">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-background-600">
                      <i className="ri-image-2-line text-[16px]" aria-hidden="true" />
                    </span>
                    <p className="en-label text-[9.5px] text-foreground-400">PHOTO</p>
                    <p className="text-[10.5px] tracking-wide text-foreground-400">写真は後日掲載</p>
                  </div>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-12 grid gap-8 border-t border-background-300 pt-10 md:mt-16 md:grid-cols-12 md:gap-10">
          <Reveal variant="up" className="md:col-span-5">
            <h3 className="font-heading text-[18px] font-black text-foreground-950 md:text-[20px]">開催概要</h3>
            <p className="mt-2.5 text-[11.5px] leading-relaxed text-foreground-500">
              開催日・会場などの確定情報は、決まり次第こちらを更新します。
            </p>
            <dl className="mt-5 divide-y divide-background-300 border-y border-background-300">
              {companyProfile.map((row) => (
                <div key={row.label} className="flex gap-4 py-3">
                  <dt className="w-24 shrink-0 text-[11.5px] font-bold text-foreground-500">{row.label}</dt>
                  <dd className="text-[12.5px] leading-relaxed text-foreground-800">{row.value}</dd>
                </div>
              ))}
            </dl>
          </Reveal>

          <Reveal variant="mask" duration={1200} className="md:col-span-7">
            <div className="overflow-hidden rounded-md border border-background-300">
              <iframe
                title="活動エリア（熊本県熊本市）の地図"
                src="https://www.google.com/maps?q=%E7%86%8A%E6%9C%AC%E7%9C%8C%E7%86%8A%E6%9C%AC%E5%B8%82%E4%B8%AD%E5%A4%AE%E5%8C%BA&output=embed"
                className="h-[260px] w-full border-0 sm:h-[320px] md:h-[380px]"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <p className="mt-3 text-[10.5px] leading-relaxed text-foreground-400">
              ※ 地図は活動エリア（熊本市中心部）を示したものです。会場は開催ごとに異なります。
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}